import React from "react";
import './summary.css';

import AppConfig from "../../config/AppConfig";
import {ContributionTable} from "../../components/Tables/ContributionTable";
import {ForecastTable} from "../../components/Tables/ForecastTable";
import {DateUtils} from "../../utils/dateUtils";

export class Summary extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            cst: DateUtils.getForecastStartCST(),
            showMap: true
        }

    }

    _renderShowMapToggle(){
        return (
            <div className={"summary-show-map-toggle"}>

                {this.props.i18n.Summary_View_As}

                <div
                    className={`summary-toggle-item ${this.state.showMap ? 'active' : ''}`}
                    onClick={() => this.setState({showMap:true})}
                >
                    {this.props.i18n.Summary_Map}
                </div>

               {this.props.i18n.Summary_Divider}

                <div
                    className={`summary-toggle-item ${!this.state.showMap ? 'active' : ''}`}
                    onClick={() => this.setState({showMap:false})}
                >
                    {this.props.i18n.Summary_Table}
                </div>

            </div>
        )
    }


    render(){

        document.title = "Kansas Flint Hills Smoke Management - Cumulative Fire Impacts";

        return(
            <div className={"summary"}>

                <div className={"summary-disclaimer"}>
                    {this.props.i18n.Summary_Disclaimer_P1}
                </div>

                <div className={"summary-table-controls"}>

                    <div>
                        <div className={"summary-paragraph"}>
                            {this.props.i18n.Summary_Range_P1}
                            { DateUtils.getStartSeason().format(AppConfig.time.displayDateFormat)}
                            {this.props.i18n.Summary_Range_P2}
                            {DateUtils.getEndSeason().format(AppConfig.time.displayDateFormat)}
                            {this.props.i18n.Summary_Range_P3}
                        </div>

                        <div className={"summary-paragraph"}>
                            {this.props.i18n.Summary_Forecast_Update}
                        </div>
                    </div>

                    {this._renderShowMapToggle()}

                </div>


                <ContributionTable
                    i18n={this.props.i18n}
                    cst={this.state.cst}
                    startDateString={this.state.cst.format(AppConfig.time.displayDateFormat)}
                    endDateString={this.state.cst.clone().add(1, "day").format(AppConfig.time.displayDateFormat)}
                    showMap={this.state.showMap}
                />

                <ForecastTable
                    i18n={this.props.i18n}
                    cst={this.state.cst}
                />

            </div>
        )
    }

}

